export const Colors = {
    BAR_BASE: '#673AB7',
    BAR_NORMAL: '#9575CD', 
    BAR_SORTED: '#00BFA5',

    BAR_MERGE_DIVIDE: '#FFD600',
    BAR_MERGE_JOIN: '#FF7043',

    BAR_BUBBLE_CURRENT: '#FFD600',
    BAR_BUBBLE_SWAP: '#FF7043',

    BAR_SELECTION_CURRENT:  '#FFD600',
    BAR_SELECTION_SWAP: '#FF7043',

    BAR_INSERTION_CURRENT:  '#FFD600',
    BAR_INSERTION_SWAP: '#FF7043',

    BAR_HEAP_CURRENT:  '#FFD600',
    BAR_HEAP_SWAP: '#FF7043',

    BAR_QUICK_SWAP: '#FF7043',
    BAR_QUICK_PIVOT:  '#FFD600',
}